/**
 * @generated SignedSource<<87e58b2a839f3a0e386c02423408618c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCustomerContact_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly entity: {
    readonly accountName?: string | null | undefined;
    readonly contactUser?: {
      readonly thirdPartyUser: {
        readonly extendedProfile: {
          readonly jobTitle: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly displayName?: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCustomerContact_AtlassianSearchPage";
};
export type searchGraphCustomerContact_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCustomerContact_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCustomerContact_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphCustomerContact_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "displayName"
            },
            {
              "kind": "ScalarField",
              "name": "accountName"
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "contactUser",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ThirdPartyUser",
                  "kind": "LinkedField",
                  "name": "thirdPartyUser",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "ThirdPartyUserExtendedProfile",
                      "kind": "LinkedField",
                      "name": "extendedProfile",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "jobTitle"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "type": "ExternalCustomerContact"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};

(node as any).hash = "dbeb15a9aac7e4bc9e241ebc3dade593";

export default node;
